var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-us",class:{english:_vm.lang=='EN'}},[_c('Header',{ref:"header",attrs:{"id":"header"}}),_vm._v(" "),_c('img',{ref:"banner",staticClass:"img-fluid",class:_vm.isMobile?'visible-xs':'hidden-xs',style:(_vm.isMobile?{marginTop:'3.5rem'}:''),attrs:{"src":require("../assets/img/news/newsbanner.jpg")}}),_vm._v(" "),_c('ComPanyNews',{staticStyle:{"position":"relative","z-index":"1"},attrs:{"id":"newsTab"}}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/News.vue?vue&type=template&id=0864fc8d&scoped=true&
// module id = null
// module chunks = 